import React, { useEffect, useState } from 'react';
import { Redirect } from "react-router-dom";
import HeaderLogo from './HeaderLogo';
import Navbar from './HeaderNavbar'
import StyleControls from './StyleControls';
import { usePopup } from '../../context/PopupContext';
import { DASHBOARD_LINK, POPUP_TYPES, APP_DOMAIN } from '../../constants/constants';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const HeaderAllInOne = (props) => {
    const popupbox = usePopup();
    const history = useHistory();
    const [redirect, setRedirect] = useState(false);
    useEffect(() => {
        popupbox.configurePopup(POPUP_TYPES);
    }, []);
    const redirectTo = (path) => {
        //history.push(path)
        window.location.href = `${APP_DOMAIN}/${path}`
    }
    if (redirect) return <Redirect to={DASHBOARD_LINK} />
    return (<>
        <div className="allinone-left">
            <div className="block-left">
                <HeaderLogo clickAction={(e) => popupbox.show('exit', null, () => (props.saveResume() || setRedirect(true)))} />
            </div>
            <div className="block-right">
                <Navbar />
            </div>
        </div>
        <div className="allinone-right">
            <StyleControls />
            <Navbar />
        </div>
    </>);
}

export default HeaderAllInOne;